// extracted by mini-css-extract-plugin
module.exports = {"vipStatus":"styles_vipStatus__BRzoG","main":"styles_main__KxeFx","content":"styles_content__n9EiO","btn":"styles_btn__3rkeR"};